export default "https://cdn.questicon.mathletics.com/assets/images/Problem-Solving_L-1cf711844d0558dc05630c19d492acf9.png";